module.exports = __webpack_public_path__ + "img/gamesdk19.e4ded0a.png";